import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const resendUserInvitation: UseCase<UserRepository, 'resendUserInvitation'> = repository => {
  return async (resendUserInvitation) => {
    await repository.resendUserInvitation(resendUserInvitation)
  }
}
